import MySIRoute from './MySIRoute'
import CreateSIRoute from './CreateSIRoute'
import ManageSIRoute from './ManageSIRoute'
import ViewOnlySIRoute from './ViewOnlySIRoute'

const routes = [new MySIRoute(), new CreateSIRoute(), new ManageSIRoute(), new ViewOnlySIRoute()]

export default routes
